import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: 'root',
      redirect: { name: 'phenotypeDisease' }
    }, {
      path: '/main',
      name: 'main',
      redirect: { name: 'phenotypeDisease' }
    }, {
      path: '/phenotypeDisease',
      name: 'phenotypeDisease',
      component: (resolve) => {
        require(['../pages/phenotypeDisease.vue'], resolve)
      }
    }, {
      path: '/genePanel',
      name: 'genePanel',
      component: (resolve) => {
        require(['../pages/genePanel.vue'], resolve)
      }
    }, {
      path: '/resourceMap',
      name: 'resourceMap',
      component: (resolve) => {
        require(['../pages/resourceMap.vue'], resolve)
      }
    }, {
      path: '*',
      redirect: { name: 'phenotypeDisease' }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js